import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { TextOperationService } from '../../../services';
import {
  DEFAULT_STYLIZE_TEXT_STATE,
  buildStylizeTextRequest,
  type StylizeTextFormState,
} from './buildRequests';
import { useRunTextOperation } from './useTextOperationMutation';
import { TEXT_OPERATION_CATALOG } from './operationCatalog';
import { PanelScaffold } from './PanelScaffold';
import type { TextPanelProps } from './panelProps';

export const StylizePanel: React.FC<TextPanelProps> = ({
  ensureSession,
  isCreatingSession = false,
  documentId,
  swatchPrompt,
  sectionId,
  onResult,
}) => {
  const [state, setState] = useState<StylizeTextFormState>(DEFAULT_STYLIZE_TEXT_STATE);
  const { run, mutation, validationError } = useRunTextOperation(
    TextOperationService.stylize,
    ensureSession,
    documentId,
    { onResult },
  );

  const needsDocument = !documentId;
  const handleSubmit = () => run((sid, docId) => buildStylizeTextRequest(state, sid, docId, sectionId));

  return (
    <PanelScaffold
      meta={TEXT_OPERATION_CATALOG.Stylize}
      needsDocument={needsDocument}
      validationError={validationError}
      mutationError={mutation.isError ? mutation.error : null}
      busy={mutation.isPending}
      starting={isCreatingSession}
      submitDisabled={
        mutation.isPending || isCreatingSession || needsDocument || state.targetStyle.trim().length === 0
      }
      submitLabel="Stylize"
      busyLabel="Stylizing…"
      onSubmit={handleSubmit}
    >
      <TextField
        label="Target voice / tone"
        value={state.targetStyle}
        onChange={e => setState(s => ({ ...s, targetStyle: e.target.value }))}
        size="small"
        fullWidth
        required
        placeholder="e.g. hardboiled, breezy, formal"
        helperText={swatchPrompt ? `Studio voice: ${swatchPrompt}` : 'Pick a voice from the studio palette or type one.'}
      />
    </PanelScaffold>
  );
};
